import { render, staticRenderFns } from "./TicketCreateEquipamentosFields.vue?vue&type=template&id=0e893736&"
import script from "./TicketCreateEquipamentosFields.vue?vue&type=script&lang=js&"
export * from "./TicketCreateEquipamentosFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports